import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 py-12 px-6">
        <div className="container mx-auto max-w-4xl">
          <h1 className="font-heading text-4xl font-bold mb-8" data-testid="terms-title">Terms & Conditions</h1>
          <div className="prose max-w-none space-y-6 text-muted-foreground">
            <p className="text-sm text-muted-foreground"><em>Last Updated: {new Date().toLocaleDateString()}</em></p>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">1. Acceptance of Terms</h2>
              <p>By accessing or using ScanMyAd ("Service"), operated by BC Leads Business Services ("Company", "we", "us"), you agree to be bound by these Terms and Conditions. If you do not agree, do not use the Service.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">2. Service Description</h2>
              <p>ScanMyAd provides AI-powered advertising compliance analysis. The Service analyzes advertising content against multi-jurisdiction regulations and platform policies. <strong>The Service does NOT constitute legal advice.</strong> Users must consult qualified legal counsel for compliance decisions.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">3. No Guarantee of Regulatory Approval</h2>
              <p>We provide compliance intelligence based on AI analysis. We do NOT guarantee:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Regulatory approval of your advertising content</li>
                <li>Platform acceptance or approval</li>
                <li>Accuracy or completeness of analysis</li>
                <li>Protection from enforcement actions</li>
              </ul>
              <p className="mt-4">Regulatory interpretations vary by jurisdiction and evolve over time. Users are solely responsible for compliance decisions.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">4. User Accounts & Subscription</h2>
              <p>You must create an account to use the Service. You agree to:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account</li>
                <li>Notify us immediately of unauthorized access</li>
                <li>Accept responsibility for all activities under your account</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">5. Subscription & Billing</h2>
              <p>Subscriptions are billed monthly in USD via Stripe. By subscribing, you authorize recurring charges. You may cancel at any time, effective at the end of the current billing period.</p>
              <p className="mt-4"><strong>Refund Policy:</strong> Refunds are provided within 7 days of initial subscription. No refunds after 7 days or for subsequent billing cycles.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">6. Acceptable Use</h2>
              <p>You may NOT:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Use the Service for illegal activities</li>
                <li>Attempt to reverse engineer or extract AI models</li>
                <li>Submit content that violates third-party rights</li>
                <li>Overload or disrupt the Service infrastructure</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">7. Intellectual Property</h2>
              <p>All Service content, including software, design, and analysis output, is owned by BC Leads Business Services. Users retain ownership of submitted advertising content. We do NOT claim ownership of user content.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">8. Limitation of Liability</h2>
              <p><strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</strong></p>
              <p className="mt-2">We are NOT liable for:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Regulatory fines or enforcement actions</li>
                <li>Platform account bans or suspensions</li>
                <li>Lost revenue or business opportunities</li>
                <li>Inaccurate or incomplete analysis</li>
                <li>Indirect, consequential, or punitive damages</li>
              </ul>
              <p className="mt-4">Our total liability is limited to the amount you paid in the preceding 12 months.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">9. Account Suspension</h2>
              <p>We reserve the right to suspend or terminate accounts for:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Violation of these Terms</li>
                <li>Non-payment of subscription fees</li>
                <li>Fraudulent or abusive behavior</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">10. Governing Law & Dispute Resolution</h2>
              <p>These Terms are governed by the laws of British Columbia, Canada. Any disputes shall be resolved through binding arbitration in British Columbia, unless prohibited by law.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">11. Changes to Terms</h2>
              <p>We may update these Terms at any time. Continued use of the Service constitutes acceptance of updated Terms.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">12. Contact Information</h2>
              <p>
                BC Leads Business Services<br />
                Unit 108, 13277 108 Avenue<br />
                Surrey, BC V3T 0A9<br />
                British Columbia, Canada<br />
                Email: support@scanmyad.com
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
